// @ts-ignore
/* eslint-disable */
///////////////////////////////////////////////////////////////////////
//                                                                   //
// this file is autogenerated by service-generate                    //
// do not edit this file manually                                    //
//                                                                   //
///////////////////////////////////////////////////////////////////////
/// <reference path = "api-auto.d.ts" />
import request from '@/utils/ajax'

/**
 * Get an project by appid
 */
export async function ProxyControllerProxyGet(
  params: Paths.ProxyControllerProxyGet.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProxyControllerProxyGet.Responses
}> {
  // /v1/proxy/{appid}
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.get(`/v1/proxy/${_params.appid}`, {
    params: _params,
  })
}

/**
 * Proxy laf by appid
 */
export async function ProxyControllerProxyPost(
  params: Paths.ProxyControllerProxyPost.BodyParameters,
): Promise<{
  error: string
  data: Paths.ProxyControllerProxyPost.Responses
}> {
  // /v1/proxy/{appid}
  let _params: { [key: string]: any } = {
    ...params,
  }
  return request.post(`/v1/proxy/${_params.appid}`, {
    ..._params,
  })
}
